import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    DefaultButton,
    PrimaryButton,
    DialogActions,
} from '@bb-ui/react-library';
import { useStyles } from './EmptyRolesDialog.styles';

interface EmptyRolesDialogProps {
    open: boolean;
    userName: string;
    onReturn: () => void;
    onProceed: () => void;
}

export const EmptyRolesDialog: React.FC<EmptyRolesDialogProps> = ({
    open,
    userName,
    onReturn,
    onProceed,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                onClose={onReturn}
                aria-labelledby="empty-roles-dialog-title"
            >
                <DialogTitle
                    onClose={onReturn}
                    id="empty-roles-dialog-title"
                    data-testid="empty-roles-dialog-title"
                    className={classes.title}
                >
                    {t('settings.editUser.emptyRolesDialog.title')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="empty-roles-dialog-description"
                        data-testid="empty-roles-dialog-description"
                        className={classes.description}
                    >
                        {/* prettier-ignore */}
                        <Trans
                            i18nKey="settings.editUser.emptyRolesDialog.description"
                            values={{ userName }}
                        >
                            User has no roles assigned. Without a role,
                            the user won't be able to access any reports or data
                            in <span lang="en">Illuminate</span>.
                            Are you sure you want to save these changes?
                        </Trans>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <DefaultButton
                        onClick={onReturn}
                        data-testid="empty-roles-dialog-cancel-button"
                    >
                        {t('general.cancel')}
                    </DefaultButton>
                    <PrimaryButton
                        onClick={onProceed}
                        data-testid="empty-roles-dialog-save-button"
                    >
                        {t('settings.editUser.saveButtonText')}
                    </PrimaryButton>
                </DialogActions>
            </Dialog>
        </>
    );
};
